import { useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";

import useLocalization from "../../hooks/useLocalization";

import DataRow from "./DataRow";
import Loading from "../ui/Loading";

import {
  Checkbox,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  Paper,
  Typography,
} from "@mui/material";

const DataTable = ({
  data,
  columns,
  onRowClick,
  subTable,
  addSubRecord,
  tableHeight,
  allowSelect,
  onSelectAll,
  onSelect,
  selectedItems,
  allowSort = true,
  onSortChange,
  orderBy,
  order,
}) => {
  const theme = useTheme();
  const { getLabel, getMessage } = useLocalization();

  const [open, setOpen] = useState(false);

  // Determine if all items are currently selected
  const isAllSelected =
    data &&
    data.length > 0 &&
    selectedItems &&
    data.every((row) => selectedItems.includes(row.id));

  const rowSelected = (id) => {
    if (!selectedItems || selectedItems.length === 0) {
      return false;
    }

    const index = selectedItems.findIndex((item) => item === id);

    if (index === -1) return false;

    return true;
  };

  const handleSelectAll = (checked) => {
    onSelectAll(checked);
  };

  const handleSelect = (id, checked) => {
    onSelect(id, checked);
  };

  const handleSort = (property) => {
    if (onSortChange) {
      const isAscending = orderBy === property && order === "asc";
      onSortChange(property, isAscending ? "desc" : "asc");
    }
  };

  return (
    <>
      {Array.isArray(columns) && columns.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{ maxHeight: tableHeight }}
        >
          <Table
            size="small"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {subTable ? (
                  <TableCell
                    key="expand"
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      width: "30px",
                    }}
                  />
                ) : null}
                {allowSelect ? (
                  <TableCell
                    key="select"
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      width: "50px",
                    }}
                  >
                    <Checkbox
                      size="small"
                      sx={{
                        padding: "0px",
                        color: "#000",
                        "&.Mui-checked": {
                          color: "#fff",
                        },
                      }}
                      onChange={(e, checked) => handleSelectAll(checked)}
                      checked={isAllSelected}
                    />
                  </TableCell>
                ) : null}
                {columns.map((column, index) => (
                  <TableCell
                    key={column.name}
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                    }}
                    width={column.width ? column.width : "auto"}
                  >
                    {column.sortable !== false && allowSort ? (
                      <TableSortLabel
                        active={orderBy === column.name}
                        direction={orderBy === column.name ? order : "asc"}
                        onClick={() => handleSort(column.name)}
                      >
                        <Typography
                          textAlign={column.textAlign}
                          sx={column.labelStyle}
                        >
                          {getLabel(column.label || column.name)}
                        </Typography>
                      </TableSortLabel>
                    ) : (
                      <Typography
                        textAlign={column.textAlign}
                        sx={column.labelStyle}
                      >
                        {getLabel(column.label || column.name)}
                      </Typography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(data) && data.length > 0
                ? data.map((row, index) => (
                    <DataRow
                      key={row.id}
                      columns={columns}
                      rowData={row}
                      subTable={subTable}
                      onRowClick={onRowClick}
                      addSubRecord={addSubRecord}
                      allowSelect={allowSelect}
                      selected={rowSelected(row.id)}
                      onSelect={(checked) => handleSelect(row.id, checked)}
                    />
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography sx={{ padding: "4px" }}>
          {getMessage("noRecords")}
        </Typography>
      )}
    </>
  );
};

export default DataTable;
